// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bdpAppMain .layout-content {
  padding: 10px 24px 0px 24px;
}
#bdpAppMain #menuWrapper.menu-wrapper {
  border-top: 1px solid var(--bdpMenuBorder);
  background-color: var(--bdpMenuBackground);
  z-index: 9999;
}
#bdpAppMain ::ng-deep .p-dialog {
  max-width: 760px !important;
}
#bdpAppMain ::ng-deep .p-dialog .p-dialog-header {
  justify-content: space-between !important;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .p-dialog-title {
  font-weight: bold;
  font-size: 18px;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .bdp-key-ref {
  padding: 1.5rem;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .bdp-key-ref h6 {
  font-weight: normal;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .bdp-key-ref .p-radiobutton-box.p-highlight {
  background-color: #fff;
  text-align: center;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .bdp-key-ref .p-radiobutton-box .p-radiobutton-icon {
  background-color: #1b74c5;
  border-radius: 6px;
  overflow: hidden;
  width: 11px;
  height: 11px;
  float: none;
  margin-left: auto;
  margin-right: auto;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .p-dialog-footer .bdp-save {
  background-color: #2d74ff;
}
#bdpAppMain ::ng-deep .bdp-key-ref-dialog .p-dialog-footer .bdp-reset {
  color: #1d2125;
  background-color: #fff;
  border-color: #1d2125;
}

::ng-deep .p-dialog {
  width: 50% !important;
}

#eulaTextArea {
  height: 150px;
  width: 100%;
  overflow: auto;
}
#eulaTextArea h4 {
  font-size: 16px;
  color: #2d74ff;
}
#eulaTextArea h3 {
  font-size: 14px;
  color: #1d2125;
}
#eulaTextArea p {
  font-size: 12px;
}

.userDetails input {
  width: 100%;
}

.bdp-save {
  background-color: #2d74ff;
}

.bdp-reset {
  color: #1d2125;
  background-color: #fff;
  border-color: #1d2125;
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/main-panel/app.main.component.scss"],"names":[],"mappings":"AACI;EACI,2BAAA;AAAR;AAIQ;EACI,0CAAA;EACA,0CAAA;EACA,aAAA;AAFZ;AAOQ;EACI,2BAAA;AALZ;AAOQ;EACI,yCAAA;AALZ;AAWY;EACI,iBAAA;EACA,eAAA;AAThB;AAYY;EACI,eAAA;AAVhB;AAYgB;EACI,mBAAA;AAVpB;AAcoB;EACI,sBAAA;EACA,kBAAA;AAZxB;AAeoB;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAbxB;AAmBgB;EACI,yBAAA;AAjBpB;AAoBgB;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;AAlBpB;;AAwBA;EACI,qBAAA;AArBJ;;AAwBA;EACI,aAAA;EACA,WAAA;EACA,cAAA;AArBJ;AAsBI;EACI,eAAA;EACA,cAAA;AApBR;AAsBI;EACI,eAAA;EACA,cAAA;AApBR;AAsBI;EACI,eAAA;AApBR;;AAyBI;EACI,WAAA;AAtBR;;AAyBA;EACI,yBAAA;AAtBJ;;AAyBA;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;AAtBJ","sourcesContent":["#bdpAppMain {\n    .layout-content {\n        padding: 10px 24px 0px 24px;\n    }\n\n    #menuWrapper {\n        &.menu-wrapper {\n            border-top: 1px solid var(--bdpMenuBorder);\n            background-color: var(--bdpMenuBackground);\n            z-index: 9999;\n        }\n    }\n\n    ::ng-deep {\n        .p-dialog {\n            max-width: 760px !important;\n        }\n        .p-dialog .p-dialog-header {\n            justify-content: space-between !important;\n        }\n    }\n\n    ::ng-deep {\n        .bdp-key-ref-dialog {\n            .p-dialog-title {\n                font-weight: bold;\n                font-size: 18px;\n            }\n\n            .bdp-key-ref {\n                padding: 1.5rem;\n\n                h6 {\n                    font-weight: normal;\n                }\n\n                .p-radiobutton-box {\n                    &.p-highlight {\n                        background-color: #fff;\n                        text-align: center;\n                    }\n\n                    .p-radiobutton-icon {\n                        background-color: #1b74c5;\n                        border-radius: 6px;\n                        overflow: hidden;\n                        width: 11px;\n                        height: 11px;\n                        float: none;\n                        margin-left: auto;\n                        margin-right: auto;\n                    }\n                }\n            }\n\n            .p-dialog-footer {\n                .bdp-save {\n                    background-color: #2d74ff;\n                }\n\n                .bdp-reset {\n                    color: #1d2125;\n                    background-color: #fff;\n                    border-color: #1d2125;\n                }\n            }\n        }\n    }\n}\n::ng-deep .p-dialog {\n    width: 50% !important;\n}\n\n#eulaTextArea {\n    height: 150px;\n    width: 100%;\n    overflow: auto;\n    h4 {\n        font-size: 16px;\n        color: #2d74ff;\n    }\n    h3 {\n        font-size: 14px;\n        color: #1d2125;\n    }\n    p {\n        font-size: 12px;\n    }\n}\n\n.userDetails {\n    input {\n        width: 100%;\n    }\n}\n.bdp-save {\n    background-color: #2d74ff;\n}\n\n.bdp-reset {\n    color: #1d2125;\n    background-color: #fff;\n    border-color: #1d2125;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
